import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import classNames from "classnames";
import Button from "../Parts/Button";
import Typography from "material-ui/Typography";
import Checkbox from "material-ui/Checkbox";
import IconButton from "material-ui/IconButton";
import ArrowDropdown from "../Icons/ArrowDropdown";
import Add from "../Icons/Add";
import MuiButton from "material-ui/Button";
import Radio, { RadioGroup } from "material-ui/Radio";
import { FormControlLabel } from "material-ui/Form";

const sectionMenu = {
  section: {
    width: "100%",
    marginBottom: '50px',
    position: "relative",
  },

  collapsed: {
    maxHeight: "200px",
    overflowY: "hidden",
  },

  sectionHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    borderBottom: "1px solid #D8DBDF",
    marginBottom: '12px',
    paddingBottom: "5px",
    position: "relative",
    cursor: "pointer",
    "&:hover": {
      "& $arrow": {
        visibility: "visible",
        opacity: 1,
      },
    },
  },

  sectionBody: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "column",
    width: "100%",
    marginTop: '8px',
  },

  entry: {
    paddingTop: '8px',
    boxSizing: "border-box",
    position: "relative",
    display: "inline-flex",
    alignItems: "flex-start",
    transition:
      "transform 1s cubic-bezier(0.77, 0, 0.175, 1), -webkit-transform 0.3s cubic-bezier(0.77, 0, 0.175, 1)",
  },

  arrow: {
    transform: "translateX(-100%)",
    position: "absolute",
    left: 0,
    visibility: "hidden",
    opacity: 0,
    width: "unset",
    height: "unset",
    transition:
      "transform 1s cubic-bezier(0.77, 0, 0.175, 1), -webkit-transform 0.3s cubic-bezier(0.77, 0, 0.175, 1)",
  },

  menuItem: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center",
  },

  subMenuItem: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    height: "30px",
    flexDirection: "row",
  },

  startAdornment: {
    width: "13px",
    height: "100%",
    borderLeft: "1px solid #D8DBDF",
    paddingRight: "4px",
  },

  rightTop: {
    height: "50%",
    width: "100%",
    borderBottom: "1px solid #D8DBDF",
  },

  rightBottom: {
    height: "50%",
    width: "100%",
  },

  text: {
    marginLeft: "5px",
    fontSize: "14px",
  },

  expandBtnContainer: {
    width: "100%",
    height: "60px",
    position: "absolute",
    bottom: 0,
  },

  gradient: {
    width: "100%",
    height: "37px",
    background: "linear-gradient(transparent 0%, white 80%)",
  },

  expandBtnOutter: {
    height: "23px",
    background: "#FFFFFF",
    padding: "0px 4px",
    boxSizing: "border-box",
  },

  button: {
    color: "#1A65FF",
    fontSize: "11px",
    minHeight: "unset",
    padding: "6px 8px",
  },

  group: {
    flexDirection: "column",
  },

  formControlLabel: {
    fontSize: "14px",
    color: "#181819",
  },

  newLabel: {
    fontWeight: "bold",
    fontSize: "10px",
    background: "#FFC62B",
    color: "#FFFFFF",
    padding: "3px 6px",
    marginLeft: "5px",
    whiteSpace: "nowrap",
    borderRadius: "3px",
  },
};

class SubmenuSection extends React.Component {
  state = {
    open: true,
    collapsed: true,
  };

  handleClick = () => {
    this.setState({
      open: !this.state.open,
    });
  };

  handleExpand = () => {
    this.setState({
      collapsed: false,
    });
  };

  handleChangeRadioGroup = (parent, child) => {
    this.props.selectSubmenuSingleSelect(parent, child);
  };

  findCurrentValue = (parent) => {
    const { set } = this.props;
    let value;

    if (set.has(parent.value) && set.get(parent.value).count() > 0) {
      value = set.get(parent.value).keySeq().first();
    } else {
      let defaultItem = parent.submenu.find((item) => item.default);
      value = defaultItem ? defaultItem.value : parent.submenu[0].value;
    }

    return value;
  };

  renderExpandBtn = () => {
    const { classes, menuItems, disabled } = this.props;

    const displayMaxItemCount = 5;
    if (menuItems && menuItems.length > displayMaxItemCount && this.state.collapsed) {
      return (
        <div className={classes.expandBtnContainer}>
          <div className={classes.gradient}></div>
          <div className={classes.expandBtnOutter}>
            <MuiButton
              color="default"
              className={classes.button}
              style={{ color: disabled ? "#B1B3B9" : "#1A65FF" }}
              onClick={this.handleExpand}
            >
              <Add
                width={10}
                height={10}
                color={disabled ? "#B1B3B9" : "#1A65FF"}
              />
              さらに表示
            </MuiButton>
          </div>
        </div>
      );
    }
  };

  renderSubMenu = (parent) => {
    const { classes, selectSubmenu, set, disabled, user } = this.props;

    if (
      Array.isArray(parent.submenu) &&
      set.has(parent.value.toString()) &&
      parent.submenu.length > 0
    ) {
      if (parent && parent.isSubmenuSingleSelect) {
        let curVal = this.findCurrentValue(parent);

        return (
          <div
            className={classes.menuItem}
            style={{ padding: "0px 0px 10px 10px" }}
          >
            <RadioGroup
              className={classes.group}
              value={curVal}
              onChange={(e) =>
                this.handleChangeRadioGroup(
                  parent.value.toString(),
                  e.target.value
                )
              }
            >
              {parent.submenu.map((item, i) => (
                <FormControlLabel
                  key={i}
                  value={item.value}
                  control={<Radio color="primary" />}
                  label={item.name}
                  classes={{ label: classes.formControlLabel }}
                />
              ))}
            </RadioGroup>
          </div>
        );
      } else {
        return (
          <div
            className={classes.menuItem}
            style={{ padding: "0px 0px 10px 10px", display: (!user || user.parent_id || user.ownership_authority_flag) ? "" : "none" }}
          >
            {parent.submenu.map((item) => {
              return (
                <div
                  className={classes.subMenuItem}
                  key={parent.value + item.value}
                >
                  <div className={classes.startAdornment}>
                    <div className={classes.rightTop}></div>
                    <div className={classes.rightBottom}></div>
                  </div>
                  <div className={classes.entry} style={{ cursor: "pointer" }}>
                    <Checkbox
                      color="primary"
                      checked={
                        set.has(parent.value) &&
                        set.get(parent.value).includes(item.value)
                      }
                      style={{
                        width: "20px",
                        height: "20px",
                      }}
                      value={item.value.toString()}
                      onChange={() =>
                        selectSubmenu(
                          parent.value.toString(),
                          item.value.toString()
                        )
                      }
                      disabled={disabled}
                    />
                    <div style={{ width: "200px", overflow: "auto" }}>
                      <Typography
                        variant="subheading"
                        style={{
                          marginLeft: "5px",
                          color: disabled ? "#B1B3B9" : "#181819",
                          whiteSpace: "nowrap",
                        }}
                        onClick={() =>
                          selectSubmenu(
                            parent.value.toString(),
                            item.value.toString()
                          )
                        }
                      >
                        {item.name}
                      </Typography>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        );
      }
    }

    return undefined;
  };

  render() {
    const {
      classes,
      title,
      menuItems,
      deselectAll,
      selectAll,
      select,
      selectSubmenu: _selectSubmenu,
      set,
      children,
      disabled,
      isSubmenuSingleSelect: _isSubmenuSingleSelect,
      selectSubmenuSingleSelect: _selectSubmenuSingleSelect,
      ...rest
    } = this.props;

    const displayMaxItemCount = 5;
    let collapsed = menuItems && menuItems.length > displayMaxItemCount && this.state.collapsed;

    return (
      <div className={classes.section} {...rest}>
        <div className={classes.sectionHeader}>
          <IconButton
            className={classes.arrow}
            style={{
              transform: this.state.open
                ? "translateX(-100%) rotate(0deg)"
                : "translateX(-100%) rotate(-90deg)",
            }}
            onClick={this.handleClick}
          >
            <ArrowDropdown color="#71737B" width={20} height={20} />
          </IconButton>

          <Typography
            variant="body2"
            style={{
              color: disabled ? "#B1B3B9" : "#181819",
              flex: 1,
              fontWeight: "bold",
            }}
            onClick={this.handleClick}
          >
            {title}
            {(menuItems && menuItems.filter(item => item.isNew === true).length > 0) && (
              <div className={classes.newLabel} style={{ display: 'inline-block', lineHeight: 'normal' }}>NEW</div>
            )}
          </Typography>
          {(() => {
            if (deselectAll) {
              return (
                <Button
                  text={set.count() === 0 ? "全選択" : "選択解除"}
                  type="ghost"
                  size="extra-small"
                  handleClickButton={
                    set.count() === 0 ? selectAll : deselectAll
                  }
                  style={{
                    color: disabled ? "#B1B3B9" : "#71737B",
                    border: "none",
                    minWidth: "unset",
                    width: "unset",
                    padding: "0px 5px",
                  }}
                />
              );
            }
          })()}
        </div>

        <div
          className={classNames(
            classes.sectionBody,
            collapsed ? classes.collapsed : ""
          )}
          style={{ display: this.state.open ? "flex" : "none" }}
        >
          {(() => {
            if (menuItems === undefined || children) {
              return children;
            } else if (menuItems.length === 0) {
              return (
                <div className={classes.entry}>
                  <Typography
                    variant="subheading"
                    style={{ color: disabled ? "#B1B3B9" : "#71737B" }}
                  >
                    {title}がありません
                  </Typography>
                </div>
              );
            } else {
              return menuItems.map((item, i) => (
                <div className={classes.menuItem} key={i}>
                  <div className={classes.entry} style={{ cursor: "pointer" }}>
                    <Checkbox
                      color="primary"
                      checked={set.has((item.id || item.value).toString())}
                      style={{
                        width: "20px",
                        height: "20px",
                      }}
                      value={(item.id || item.value).toString()}
                      onChange={() =>
                        select((item.id || item.value).toString())
                      }
                      disabled={disabled}
                    />
                    <Typography
                      variant="subheading"
                      style={{ color: disabled ? "#B1B3B9" : "#181819" }}
                      className={classes.text}
                      onClick={() => select((item.id || item.value).toString())}
                    >
                      {item.name}
                    </Typography>
                    {!!item.isNew && (
                      <div className={classes.newLabel}>NEW</div>
                    )}
                  </div>
                  {this.renderSubMenu(item)}
                </div>
              ));
            }
          })()}
          {this.renderExpandBtn()}
        </div>
      </div>
    );
  }
}

SubmenuSection.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  menuItems: PropTypes.array,
  deselectAll: PropTypes.func,
  selectAll: PropTypes.func,
  select: PropTypes.func,
  selectSubmenu: PropTypes.func,
  set: PropTypes.object,
  disabled: PropTypes.bool,
  selectSubmenuSingleSelect: PropTypes.func,
  user: PropTypes.object,
  children: PropTypes.node,
  isSubmenuSingleSelect: PropTypes.bool,
};

export default withStyles(sectionMenu)(SubmenuSection);



// WEBPACK FOOTER //
// ./src/components/common/SubmenuSection.jsx